// src/features/eventos/domain/eventosListUtils.js

export const norm = (s) =>
    (s ?? "")
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

export const buildSearchText = (evento) => {
    const chunks = [];

    chunks.push(evento?.nombre, evento?.fechaInicio, evento?.fechaFin);
    chunks.push(evento?.esProvisional ? "provisional" : "definitivo");

    // Menús y platos
    (evento?.menus || []).forEach((m) => {
        chunks.push(m?.nombre);
        (m?.platos || []).forEach((p) => chunks.push(p?.nombre));
    });

    // Cacerías (nombre)
    (evento?.cacerias || []).forEach((c) => chunks.push(c?.nombre));

    // Participaciones (persona + habitaciones + vinos + actividades)
    (evento?.participaciones || []).forEach((part) => {
        const persona = part?.persona || {};
        chunks.push(
            persona?.nombre,
            persona?.nombre2,
            persona?.apellidos,
            persona?.nickname,
            persona?.email,
            persona?.telefono,
            persona?.direccion,
            persona?.provincia,
            persona?.pais,
            persona?.codigoPostal
        );

        (part?.habitaciones || []).forEach((h) => chunks.push(h?.numero, h?.nombre));
        (part?.vinos || []).forEach((v) => chunks.push(v?.nombre));
        (part?.actividades || []).forEach((a) => chunks.push(a?.nombre));
    });

    return norm(chunks.filter(Boolean).join(" | "));
};

export const toSpanishDate = (s) => {
    if (!s) return "";
    const [yyyy, mm, dd] = String(s).split("-");
    if (!yyyy || !mm || !dd) return s;
    return `${dd}-${mm}-${yyyy}`;
};

export const isEventoPasado = (evento) => {
    const fecha = evento?.fechaFin || evento?.fechaInicio;
    if (!fecha) return false;
    const d = new Date(fecha);
    if (isNaN(d.getTime())) return false;
    d.setHours(23, 59, 59, 999); // el evento sigue "vigente" durante todo su último día
    return d.getTime() < Date.now();
};

export const sortEventos = (list, orden) => {
    const copia = [...(list || [])];

    const parseDate = (s) => {
        if (!s) return null;
        const d = new Date(s);
        return isNaN(d.getTime()) ? null : d;
    };

    copia.sort((a, b) => {
        if (orden === "nombreAsc" || orden === "nombreDesc") {
            const na = (a?.nombre || "").toLowerCase();
            const nb = (b?.nombre || "").toLowerCase();
            if (na < nb) return orden === "nombreAsc" ? -1 : 1;
            if (na > nb) return orden === "nombreAsc" ? 1 : -1;
            return 0;
        }

        const da = parseDate(a?.fechaInicio || a?.fechaFin);
        const db = parseDate(b?.fechaInicio || b?.fechaFin);

        if (!da && !db) return 0;
        if (!da) return 1;
        if (!db) return -1;

        const diff = da - db;
        return orden === "fechaAsc" ? diff : -diff;
    });

    return copia;
};
